import React, { useState, useMemo, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import ModalDialog from 'app/components/organisms/ModalDialog/ModalDialog';
import TreeCheckboxes from 'app/components/molecules/TreeCheckboxes/TreeCheckboxes';
import { TextField, Button } from '@mic3/platform-ui';

const AttributeModal = ({ onClose, onApply, entityTreeValue, updateAttributesOrder, value: attributesListValue }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [localTreeValue, setLocalTreeValue] = useState(entityTreeValue);
    const [updatedAttributes, setUpdatedAttributes] = useState(attributesListValue);

    useEffect(() => {
        setLocalTreeValue(entityTreeValue);
    }, [entityTreeValue]);
    useEffect(() => {
        setUpdatedAttributes(attributesListValue);
    }, [attributesListValue]);

    const filteredTreeValue = useMemo(() => {
        if (!searchTerm) return localTreeValue;
        const filterTree = (nodes) =>
            nodes
                .map(node => {
                    const children = node.children ? filterTree(node.children) : [];
                    if (node.label.toLowerCase().includes(searchTerm.toLowerCase()) || children.length > 0) {
                        return { ...node, children };
                    }
                    return null;
                })
                .filter(Boolean);
        return filterTree(localTreeValue);
    }, [searchTerm, localTreeValue]);

    const handleApply = useCallback(() => {
        onApply(localTreeValue, updatedAttributes)
        onClose();
    }, [localTreeValue, onApply, onClose, updatedAttributes]);

    const onChangeTree = useCallback(({ target: { value } }, nodes) => {
        let attributesList = updateAttributesOrder(updatedAttributes, nodes);
        attributesList = attributesList.map((val) => ({
            value: val.value,
            label: val.label,
            order: val.order,
            fieldType: val.fieldType,
        }));
        setLocalTreeValue(value);

        setUpdatedAttributes(attributesList);
    }, [updatedAttributes, updateAttributesOrder]);

    return (
        <ModalDialog
            title="Add attributes"
            onClose={onClose}
            actions={
                <Button onClick={handleApply}>
                    Apply
                </Button>
            }
        >
            <TextField
                label="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                fullWidth
                margin="normal"
            />
            <TreeCheckboxes
                name="classesDefintions"
                onChange={onChangeTree}
                value={filteredTreeValue}
            />
        </ModalDialog>
    );
};

AttributeModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onApply: PropTypes.func.isRequired,
    entityTreeValue: PropTypes.array.isRequired,
};

export default AttributeModal;